import { useAppSelector } from 'state/hooks';

import { useGetPlanningVolumesQuery } from '../../state/apiSlice';
import {
  selectBinSize,
  selectProject,
  selectSegmentId,
  selectTypicalMonth,
} from '../../state/workflowSlice';

export function usePlanningVolumesDataProvider(skip = false) {
  const project_slug = useAppSelector(selectProject);
  const typicalMonth = useAppSelector(selectTypicalMonth);
  const segmentId = useAppSelector(selectSegmentId);
  const binSize = useAppSelector(selectBinSize);

  // typicalData from REST api
  const { currentData: planningVolumeData } = useGetPlanningVolumesQuery(
    { project_slug, typicalMonth, segmentId, binSize },
    { skip: skip || !(typicalMonth && segmentId) },
  ) as any;

  return planningVolumeData;
}
